import React, { useEffect } from "react";
import { Button, message, Space, Switch } from "antd";
import { YhBox } from "../../../../components2/YhBox";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { IVehicleDetail } from "../vehicleTypes"
import { useVehicleModel } from "../vehicleModel"
import { DetailType } from "../../../../types/FmsEnums";
import { useNavModel } from "../../../../model/navModel";
import { globalPrompt } from "../../../../components2/YhMessage"
import moment, { Moment } from "moment";

const VehicleList = () => {
    const { dataSource, page, selectedRowKeys, selectedRow, loadData, setSelectedRowKeys, cutDisabled, setSelectedRow } = useVehicleModel()
    const { addNav } = useNavModel()
    useEffect(() => {
        loadData()
    }, [])
    const columns: ColumnsType<IVehicleDetail> = [
        {
            title: '序号',
            render: (text, record, index) => `${index + 1}`
        },
        {
            title: '分支编码',
            dataIndex: 'branch',
        },
        {
            title: '数据版本号',
            dataIndex: 'ver',
        },
        {
            title: '车辆牌照',
            dataIndex: 'licensePlate',
        },
        {
            title: '车辆品牌',
            dataIndex: 'brandName',
        },
        {
            title: '车系',
            dataIndex: 'series',
        },
        {
            title: '车型',
            dataIndex: 'model',
        },
        {
            title: '车辆类型',
            dataIndex: 'categoryName',
        },
        {
            title: '*Vin码',
            dataIndex: 'vin',
        },
        {
            title: '发动机号',
            dataIndex: 'engineCode',
        },
        {
            title: '生产日期',
            dataIndex: 'productionTime',
            render: (text) => text ? moment(text).format("YYYY-MM-DD HH:mm:ss") : ""
        },
        {
            title: '出场日期',
            dataIndex: 'deliveryTime',
            render: (text) => text ? moment(text).format("YYYY-MM-DD HH:mm:ss") : ""
        },
        {
            title: '注册日期',
            dataIndex: 'registerDate',
            render: (text) => text ? moment(text).format("YYYY-MM-DD HH:mm:ss") : ""
        },
        {
            title: '登记日期',
            dataIndex: 'createTime',
            render: (text) => text ? moment(text).format("YYYY-MM-DD HH:mm:ss") : ""
        },
        {
            title: '备注',
            dataIndex: 'note',
        },
        {
            title: '状态',
            dataIndex: 'enable',
            render: (text, record) => (
                <Space size="middle">
                    {/* checked={record.materialStatus == 0} */}
                    <Switch checked={record.enable === 1} onChange={(checked) => {
                        // onDisabled(record.id, checked);
                        cutDisabled(record, checked)
                    }} />
                </Space>
            ),

        }
    ];
    const onDetail = (type: string) => {
        const id = selectedRowKeys[0] as string //这里做类型转换

        switch (type) {
            case DetailType.add:
                return addNav("2-7-1", { id: "", mode: type })
            case DetailType.edit:
                if (selectedRowKeys.length == 0) return globalPrompt("message", { type: "error", text: "选择您要编辑的数据" })
                return addNav("2-7-2", { id, mode: type });
            case DetailType.look:
                if (selectedRowKeys.length == 0) return globalPrompt("message", { type: "error", text: "选择您要查看的数据" })
                return addNav("2-7-3", { id, mode: type });
            default:
                return false
        }
    }
    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => onDetail("add")}
        >新增</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => onDetail("edit")}
        >编辑</Button>
        {/* <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => onDetail("look")}
        >查看</Button> */}
    </>
    const rowSelection = {
        onChange(selectedRowKeys: React.Key[], selectedRows: IVehicleDetail[]) {
            setSelectedRowKeys(selectedRowKeys)
            setSelectedRow(selectedRows)
        },
        selectedRowKeys
    }
    const onRow = (record: IVehicleDetail) => {
        return {
            onClick: () => {
                if (selectedRowKeys.length > 0 && selectedRowKeys[0] === record.key) {
                    setSelectedRowKeys([])
                    setSelectedRow([])
                } else {
                    setSelectedRowKeys([record.key as string])
                    setSelectedRow([record])
                }
            },
        }
    }
    return (
        <YhBox action={action}>
            <Table
                columns={columns}
                dataSource={dataSource}
                rowSelection={{
                    type: "radio",
                    ...rowSelection
                }}
                onRow={onRow}
                pagination={{
                    ...page,
                    position: ["bottomCenter"],
                    showTotal: () => `共${page.total}条`,
                    onChange: (pageNum, pageSize) => {
                        loadData({ pageNum, pageSize })
                    }
                }}
                scroll={{ x: 'max-content' }}
            />
        </YhBox>
    )
}
export default VehicleList